import type { ContentfulAsset, Settings } from '@models/contentful';
import { defaultLocale } from '@helpers/shared/common';
import MicrocopyHelper from '@helpers/microcopy';

export interface AppState {
    microcopy: MicrocopyHelper;
    assets: Record<string, ContentfulAsset>;
    pages: Record<string, Record<string, string>>;
    urls: Record<string, string>;
    settings?: Settings;
}

export const initialAppState: AppState = {
    microcopy: new MicrocopyHelper(defaultLocale),
    assets: {},
    pages: {},
    urls: {},
    settings: undefined,
};
